import { render, staticRenderFns } from "./video.module.vue?vue&type=template&id=5aabb0e2&scoped=true"
import script from "./video.module.vue?vue&type=script&lang=js"
export * from "./video.module.vue?vue&type=script&lang=js"
import style0 from "./video.module.vue?vue&type=style&index=0&id=5aabb0e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aabb0e2",
  null
  
)

export default component.exports